var React = require('react');

function In (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.4004 0H1.70893C0.796874 0 0 0.65625 0 1.55759V18.2862C0 19.1924 0.796874 20 1.70893 20H18.3955C19.3125 20 20 19.1871 20 18.2862V1.55759C20.0053 0.65625 19.3125 0 18.4004 0ZM6.19954 16.671H3.33437V7.7625H6.19954V16.671ZM4.86606 6.40804H4.84553C3.92857 6.40804 3.33482 5.72545 3.33482 4.87098C3.33482 4.00089 3.94419 3.33438 4.88169 3.33438C5.81919 3.33438 6.39285 3.99598 6.41338 4.87098C6.41294 5.72545 5.81919 6.40804 4.86606 6.40804ZM16.671 16.671H13.8058V11.8C13.8058 10.633 13.3888 9.83572 12.3522 9.83572C11.5603 9.83572 11.0915 10.3714 10.883 10.8933C10.8049 11.0808 10.7839 11.3362 10.7839 11.5969V16.671H7.91874V7.7625H10.7839V9.00223C11.2009 8.40848 11.8522 7.55402 13.3678 7.55402C15.2486 7.55402 16.6714 8.79375 16.6714 11.4665L16.671 16.671Z","fill":"#6DC0F8"}));
}

In.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = In;

In.default = In;
